module.exports = __webpack_public_path__ + "img/bn_0.a16e916c.png";